import React from 'react';
import { 
  Shield, Users, BarChart3, LogOut, UserCheck, Wallet, Settings as SettingsIcon, CreditCard, ShoppingCart, FileText, History, X
} from 'lucide-react';

const PartnerAdminSidebar = ({ 
  activeTab, 
  setActiveTab, 
  handleLogout,
  appSettings,
  appSettingsLoaded,
  appSafeSettings,
  sidebarOpen = false,
  setSidebarOpen
}) => {
  // Menu for PARTNER_ADMIN role (full access like superadmin for subscriptions/orders)
  const menuItems = [
    { id: 'overview', icon: BarChart3, label: 'Overview' },
    { id: 'users', icon: Users, label: 'Users' },
    { id: 'user-approvals', icon: UserCheck, label: 'User Approvals' },
    { id: 'subscriptions', icon: CreditCard, label: 'Plans' },
    { id: 'subscription-management', icon: Wallet, label: 'Subscription Management' },
    { id: 'order-management', icon: ShoppingCart, label: 'Order Management' },
    { id: 'reports', icon: FileText, label: 'Reports' },
    { id: 'partner-wallet', icon: Wallet, label: 'Partner Wallet' },
    { id: 'partner-wallet-ledger', icon: History, label: 'Wallet Ledger' },
    { id: 'settings', icon: SettingsIcon, label: 'Settings' },
  ];

  return (
    <div className={`admin-sidebar ${sidebarOpen ? 'mobile-open' : ''} fixed top-0 left-0 bottom-0 w-80 bg-gradient-to-b from-indigo-600 to-blue-600 text-white flex flex-col z-50`}>
      {/* Header */}
      <div className="p-6 border-b border-white/10">
        <div className="flex items-center gap-3 mb-2">
          {appSettings?.product_logo ? (
            <img
              src={appSettings.product_logo}
              alt="Logo"
              className="h-8 w-auto object-contain"
            />
          ) : (
            <Shield size={32} className="text-white" />
          )}
          <div className="flex-1">
            <div className={`app-name-container ${appSettingsLoaded ? 'loaded' : ''}`}>
              <h2 className="text-xl font-bold text-white">
                {appSafeSettings?.product_name}
              </h2>
            </div>
            {!appSettingsLoaded && (
              <div className="app-name-placeholder mb-2" style={{height: '1.75rem', backgroundColor: 'rgba(255,255,255,0.3)'}}></div>
            )}
            <p className="text-sm text-white/80">
              Partner Dashboard
            </p>
          </div>
          {/* Mobile Close Button */}
          <button
            onClick={() => setSidebarOpen && setSidebarOpen(false)}
            className="md:hidden bg-white/10 hover:bg-white/20 rounded p-1 transition-colors"
          >
            <X size={20} />
          </button>
        </div>
      </div>

      {/* Navigation */}
      <nav className="flex-1 p-6">
        <div className="space-y-2">
          {menuItems.map((item) => (
            <button
              key={item.id}
              onClick={() => setActiveTab(item.id)}
              className={`
                w-full p-4 rounded-lg text-left transition-all duration-200
                flex items-center gap-3 text-sm font-medium
                ${activeTab === item.id 
                  ? 'bg-white/20 text-white border-l-4 border-white' 
                  : 'text-white/80 hover:bg-white/10 hover:text-white'
                }
              `}
            >
              <item.icon size={18} />
              {item.label}
            </button>
          ))}
        </div>
      </nav>

      {/* Logout */}
      <div className="p-6 border-t border-white/10">
        <button
          onClick={handleLogout}
          className="w-full p-3 bg-white/10 hover:bg-white/20 border border-white/20 rounded-lg text-white transition-all duration-200 flex items-center justify-center gap-2 text-sm font-medium"
        >
          <LogOut size={16} />
          Logout
        </button>
      </div>
    </div>
  );
};

export default PartnerAdminSidebar;